import React from 'react';
import { Link } from 'react-router-dom';
import '../App.css';

const Footer = () => {
  return (
    <footer className="footer-container">
      <div className="footer-content-stacked">
        <p className="footer-copyright">
          © 2026 ShokIQ. All rights reserved.
        </p>

        <div className="footer-links">
          <Link to="/pre-order" className="footer-link">Pre-order</Link>
          <span className="footer-divider">|</span>
          <Link to="/about" className="footer-link">About</Link>
          <span className="footer-divider">|</span>
          <Link to="/philosophy" className="footer-link">Tuning philosophy</Link>
          <span className="footer-divider">|</span>
          <Link to="/support" className="footer-link">Support</Link>
          <span className="footer-divider">|</span>
          <Link to="/privacypolicy" className="footer-link">Privacy Policy</Link>
          <span className="footer-divider">|</span>
          <Link to="/tos" className="footer-link" title="Terms of Service">
            TOS
          </Link>
        </div>

        <p className="footer-note">
          Questions about ShokIQ hardware or the portal?{' '}
          <Link to="/support" className="footer-link" style={{ textDecoration: 'underline' }}>
            Contact support
          </Link>
          {' '}or visit the{' '}
          <Link to="/help" className="footer-link">Help Center</Link>.
        </p>
      </div>
    </footer>
  );
};

export default Footer;
